export default {
	'community-plans':{
		sourceGroup:['community_plan_labels'],
		route:'community-plans',
		zoom:[10,12.5]
	},
	dimensions:{
		route:'unlock-parcel',
		routeParam:'parcelId',
		zoom:[16,22],
		priority:1,
	},
	parcels:{
		route:'parcels',
		zoom:[16,22]
	},
	poi:{
		route:'poi',
		priority:1
	},
	'sewer-mains':{
		route:'sewer-main',
		zoom:[16,22]
	},
	'water-mains':{
		route:'water-main',
		zoom:[16,22]
	},
	'zoning':{
		sourceGroup:['zoning_labels'],
		route:'zoning',
		zoom:[12.5,16]
	},
}


// WEBPACK FOOTER //
// ./src/config/map-layers-interactive.js